var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtRetirement = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 77,
    viewBox: "0 0 89 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.794 2.608h-.291l-.32 2.563C.943 4.948 0 3.888 0 2.608 0 1.168 1.192 0 2.663 0h.44a2.71 2.71 0 0 1 1.37.376h.004a2.6 2.6 0 0 1 1.275 1.976c.008.08.013.164.013.246v.01a2.813 2.813 0 0 1-.068.578c-.075.324-.21.628-.398.893-.026.037-.055.072-.08.107-.022.026-.04.055-.063.08a2.61 2.61 0 0 1-.649.553 2.68 2.68 0 0 1-1.406.396h-.44c-.066 0-.13-.005-.194-.009l.324-2.598h.003z",
    id: "efrgk11kya"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.15,
    cx: 44.5,
    cy: 73.667,
    rx: 44.5,
    ry: 2.333
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5B045",
    d: "M15.434 46.872 1.168 45.84 24.496 5.688zM66.206 15.994l5.381-12.98-47.09 2.674zM24.496 5.688 50.942 28.97 34.077 39.225z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E7DD",
    d: "m24.496 5.688 41.71 10.306L50.942 28.97zM24.496 5.688l-9.062 41.184 18.643-7.647z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.952.097a.665.665 0 0 1 .906.208l46.245 72.936h-1.55L20.74.985a.637.637 0 0 1 .213-.888z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.124 20.872c-14.015 8.523-25.429 17.733-31.7 25.059l-1.256-.09 5.169-6.623 16.41-18.733 16.067-9.77 24.42-6.098 8.353-1.603-.473 1.142c-9.487 2.256-22.975 8.191-36.99 16.714v.002z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m1.168 45.84 5.169-6.622 18.16-33.53zM71.587 3.014l-8.35 1.603-38.74 1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m24.496 5.688 14.318 5.028-16.065 9.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "m24.496 5.688 38.74-1.071-24.422 6.099zM24.496 5.688 6.337 39.218l16.412-18.733z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.024 39.755)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m8.626 30.266 3.442-19.97 1.335.22L9.96 30.487z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m12.737 13.148-.88-.612.43-2.41.493.079.43.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "M2.616 31.22 49.76 15.44l.79 2.265L3.408 33.486z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 5.282,
    cy: 31.578,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m28.682 25.024-2.396-1.727 2.815-.943 2.396 1.729z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "M0 2.253 1.45.325l43.297 31.229-1.45 1.928z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 42.938,
    cy: 31.716,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 43.784,
    cy: 31.716,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "m9.472 30.267 3.442-19.971 1.335.22-3.442 19.972z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#542E0F",
    d: "M13.585 13.148h-.88l.43-3.022.493.079.43.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#522D0E",
    d: "m4.254 33.486 47.144-15.782-.79-2.266L3.462 31.22l-.055 2.267z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 6.128,
    cy: 31.578,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "M29.528 25.024h-.846l-1.55-1.727 2.816-.943 2.395 1.729z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "m.846 2.255 43.299 31.231 1.448-1.928-11.277-8.136h-.846l.38-.335L2.295.327H1.45z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#733F14",
    d: "m8.626 30.266 3.442-19.97 1.335.22L9.96 30.487z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m12.737 13.148-.88-.612.43-2.41.493.079.43.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784114",
    d: "M2.616 31.22 49.76 15.44l.79 2.265L3.408 33.486z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 5.282,
    cy: 31.578,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733F14",
    d: "m28.682 25.024-2.396-1.727 2.815-.943 2.396 1.729z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#824716",
    d: "M0 2.253 1.45.325l43.297 31.229-1.45 1.928z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 42.938,
    cy: 31.716,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "M50.608 15.438h-.846l.79 2.266h.846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "M45.593 31.558h-.847L43.3 33.486h.846z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5E3411"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.721 17.035c0 .575.476 1.04 1.063 1.04.586 0 1.062-.465 1.062-1.04 0-.574-.476-1.04-1.062-1.04-.587 0-1.063.466-1.063 1.04zM1.232 2.453c0 .575.476 1.041 1.062 1.041.587 0 1.063-.466 1.063-1.04 0-.575-.476-1.041-1.063-1.041-.586 0-1.062.466-1.062 1.04z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M62.134 55.752h3.28v2.08h-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.413 55.752h3.278v2.08h-3.278z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M68.691 55.752h3.28v2.08h-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M71.97 55.752h3.278v2.08H71.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M75.248 55.752h3.28v2.08h-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.745 56.79c0 .575.476 1.04 1.062 1.04.587 0 1.063-.465 1.063-1.04 0-.574-.476-1.04-1.063-1.04-.586 0-1.062.466-1.062 1.04z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.868 66.521c4.236 0 8.66-1.281 13.018-3.799 4.503-2.602 7.31-5.552 7.427-5.676h-3.28c-.027.03-3.102 2.385-6.556 4.555-3.93 2.466-8.323 5.09-15.059 3.486-10.114-2.409-21.577-22.89-21.692-23.096h-3.28c3.684 7.636 11.166 21.333 24.749 23.99 1.534.301 3.082.542 4.669.542l.004-.002z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M78.527 55.752h3.278v2.08h-3.278zM32.038 41.17h3.278v2.08h-3.278z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M28.76 41.17h3.278v2.08H28.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.481 41.17h3.278v2.08h-3.278z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M22.202 41.17h3.28v2.08h-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.924 41.17h3.278v2.08h-3.278z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M15.645 41.17h3.28v2.08h-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.256 42.209c0 .574.475 1.04 1.062 1.04.587 0 1.062-.466 1.062-1.04 0-.575-.475-1.04-1.062-1.04-.587 0-1.062.465-1.062 1.04z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.976 42.209c0 .574.476 1.04 1.062 1.04.587 0 1.063-.466 1.063-1.04 0-.575-.476-1.04-1.063-1.04-.586 0-1.062.465-1.062 1.04zM77.466 56.79c0 .575.475 1.04 1.062 1.04.587 0 1.062-.465 1.062-1.04 0-.574-.475-1.04-1.062-1.04-.587 0-1.062.466-1.062 1.04z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.588 66.521c4.237 0 8.661-1.281 13.018-3.799 4.504-2.602 7.311-5.552 7.428-5.676h-3.278c-.028.03-2.104 1.938-5.72 4.308-3.88 2.543-9.161 5.335-15.895 3.73-10.115-2.408-21.578-22.888-21.693-23.094h-3.277c.476.858 11.578 21.255 22.095 23.762 1.521.362 5.733.77 7.32.77h.002z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.698 42.209c0 .574.476 1.04 1.063 1.04s1.062-.466 1.062-1.04c0-.575-.475-1.04-1.062-1.04-.587 0-1.063.465-1.063 1.04zM74.188 56.79c0 .575.476 1.04 1.062 1.04.587 0 1.063-.465 1.063-1.04 0-.574-.476-1.04-1.063-1.04-.586 0-1.062.466-1.062 1.04z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.31 66.521c4.237 0 8.662-1.281 13.019-3.799 4.503-2.602 7.31-5.552 7.427-5.676h-3.28c-.027.03-1.904 2.022-6.295 4.555-4.022 2.318-8.584 5.09-15.318 3.486-10.114-2.409-21.577-22.89-21.692-23.096h-3.28c.377 1.37 11.322 21.322 21.841 23.829 1.522.363 5.99.705 7.577.705l.001-.004z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.42 42.209c0 .574.475 1.04 1.061 1.04.587 0 1.063-.466 1.063-1.04 0-.575-.476-1.04-1.063-1.04-.586 0-1.062.465-1.062 1.04zM70.909 56.79c0 .575.475 1.04 1.062 1.04.587 0 1.062-.465 1.062-1.04 0-.574-.475-1.04-1.062-1.04-.587 0-1.062.466-1.062 1.04z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.031 66.521c4.237 0 8.661-1.281 13.018-3.799 4.504-2.602 7.311-5.552 7.428-5.676h-3.278c-.028.03-1.611 1.638-6.002 4.17-4.022 2.32-8.877 5.473-15.611 3.869-10.115-2.409-21.578-22.89-21.693-23.095h-3.277c.475.858 11.235 21.124 21.754 23.63 1.522.364 6.076.903 7.663.903l-.002-.002z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.141 42.209c0 .574.476 1.04 1.063 1.04s1.062-.466 1.062-1.04c0-.575-.475-1.04-1.062-1.04-.587 0-1.063.465-1.063 1.04zM67.631 56.79c0 .575.476 1.04 1.062 1.04.587 0 1.063-.465 1.063-1.04 0-.574-.476-1.04-1.063-1.04-.586 0-1.062.466-1.062 1.04z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.753 66.521c4.237 0 8.662-1.281 13.019-3.799 4.503-2.602 7.31-5.552 7.427-5.676h-3.28c-.027.03-2.243 2.006-6.633 4.538-4.023 2.32-8.246 5.105-14.982 3.5C34.19 62.677 22.727 42.197 22.612 41.99h-3.28c.476.858 11.287 21.51 21.806 24.014 1.521.363 6.025.517 7.612.517h.003z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.862 42.209c0 .574.476 1.04 1.062 1.04.587 0 1.063-.466 1.063-1.04 0-.575-.476-1.04-1.063-1.04-.586 0-1.062.465-1.062 1.04zM64.352 56.79c0 .575.475 1.04 1.062 1.04.587 0 1.062-.465 1.062-1.04 0-.574-.475-1.04-1.062-1.04-.587 0-1.062.466-1.062 1.04z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.474 66.521c4.237 0 8.661-1.281 13.018-3.799 4.504-2.602 7.311-5.552 7.428-5.676h-3.278c-.028.03-2.224 2.04-5.863 4.34-3.92 2.478-9.018 5.305-15.752 3.699-10.115-2.409-21.578-22.89-21.693-23.095h-3.277c.476.858 11.087 21.003 21.604 23.507 1.521.363 6.226 1.024 7.811 1.024h.002z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.196 66.521c4.237 0 8.662-1.281 13.019-3.799 4.503-2.602 7.31-5.552 7.427-5.676l-.69-.624c-.028.03-2.847 2.989-7.238 5.521-4.022 2.32-10.229 4.748-16.963 3.144-10.115-2.409-21.578-22.89-21.692-23.096l-.826.44c.476.859 11.777 21.046 22.296 23.55 1.522.364 3.082.542 4.67.542l-.003-.002z",
    fill: "#DB1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.378 42.353c0 .356-.067.687-.182.96H16.183v-1.325h20.171c.015.115.024.237.024.362v.003z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.157 65.713c2.476-.4 6.91-2.38 6.91-2.38l.055-.226c.109.072.216.142.325.21 1.198-.611 2.305-1.284 3.334-1.934 2.629-1.663 4.505-3.173 5.355-3.893v-.7H82.87c0 .575-.476 1.04-1.063 1.04h-.293a37.23 37.23 0 0 1-6.627 4.892c-4.356 2.518-8.781 3.8-13.018 3.8-.517 0-1.03-.028-1.542-.074-.58.048-1.16.073-1.737.073-.395 0-.952-.025-1.587-.068-.566.044-1.13.068-1.69.068-.403 0-.992-.022-1.67-.06-.54.04-1.076.06-1.608.06-.365 0-.89-.03-1.497-.077-.598.05-1.192.077-1.783.077-.466 0-1.184-.013-2.006-.042-.425.026-.85.042-1.273.042-.908 0-2.834-.217-4.601-.47 1.263-.007 3.572-.064 5.284-.338h-.002z",
    fill: "#000",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.806 58.116H62.134V56.79h20.734c0 .733-.476 1.326-1.062 1.326z",
    fill: "#000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.196 66.521c4.237 0 8.662-1.281 13.019-3.799 4.503-2.602 7.31-5.552 7.427-5.676l-.69-.624c-.028.03-2.847 2.989-7.238 5.521-4.022 2.32-10.229 4.748-16.963 3.144-10.115-2.409-21.578-22.89-21.692-23.096l-.826.44c.476.859 11.777 21.046 22.296 23.55 1.522.364 3.082.542 4.67.542l-.003-.002z",
    fill: "#106275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.584 42.209c0 .574.476 1.04 1.063 1.04s1.062-.466 1.062-1.04c0-.575-.475-1.04-1.062-1.04-.587 0-1.063.465-1.063 1.04zM61.074 56.79c0 .575.476 1.04 1.062 1.04.587 0 1.063-.465 1.063-1.04 0-.574-.476-1.04-1.063-1.04-.586 0-1.062.466-1.062 1.04z",
    fill: "#D61A1A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.508 39.755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.566 17.036c0 .574.476 1.04 1.062 1.04.587 0 1.063-.466 1.063-1.04 0-.575-.476-1.04-1.063-1.04-.586 0-1.062.465-1.062 1.04zM2.076 2.454c0 .575.476 1.04 1.063 1.04S4.2 3.03 4.2 2.455c0-.574-.475-1.04-1.062-1.04-.587 0-1.063.466-1.063 1.04z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1B1B",
    d: "M1.883 1.817h1.354v1.326H1.883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m8.625 30.267 3.441-19.971 1.335.22L9.96 30.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m12.736 13.148-.881-.611.431-2.41.493.078.43.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "m2.613 31.221 47.144-15.78.791 2.265-47.144 15.78z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 5.281,
    cy: 31.579,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m28.68 25.025-2.395-1.728 2.815-.943 2.396 1.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "M0 2.253 1.45.325l43.297 31.229-1.45 1.928z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 42.936,
    cy: 31.717,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 43.782,
    cy: 31.717,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "m9.47 30.267 3.442-19.97 1.335.22-3.441 19.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#542E0F",
    d: "M13.583 13.148h-.88l.43-3.022.493.08.43.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m4.25 33.487 47.146-15.783-.79-2.265L3.46 31.22l-.056 2.268z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 6.127,
    cy: 31.579,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "M29.527 25.025h-.846l-1.55-1.728 2.815-.943 2.396 1.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "m.845 2.255 43.298 31.232 1.448-1.928-11.277-8.136h-.846l.38-.336L2.295.327h-.847z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m8.625 30.267 3.441-19.971 1.335.22L9.96 30.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m12.736 13.148-.881-.611.431-2.41.493.078.43.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "m2.613 31.221 47.144-15.78.791 2.265-47.144 15.78z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 5.281,
    cy: 31.579,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m28.68 25.025-2.395-1.728 2.815-.943 2.396 1.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "M0 2.253 1.45.325l43.297 31.229-1.45 1.928z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 42.936,
    cy: 31.717,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "M50.606 15.44h-.846l.79 2.264h.846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "M45.591 31.559h-.846l-1.448 1.928h.846z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#A16F31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.438 63.555 6.327-8.287 1.795 1.315-6.327 8.287z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.37 56.12.81-1.061 1.795 1.315-.81 1.061z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.65 63.073a.654.654 0 0 0 .136.928c.299.22.724.158.948-.135a.654.654 0 0 0-.137-.927.684.684 0 0 0-.945.134h-.003z",
    fill: "#BE7A2F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m17.983 63.555 6.327-8.287 1.795 1.314-6.327 8.287z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m23.913 56.122.81-1.062 1.796 1.315-.81 1.062zM19.193 63.073a.653.653 0 0 0 .137.928c.299.22.725.158.947-.135a.653.653 0 0 0-.137-.927.689.689 0 0 0-.95.134h.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#453021",
    d: "M12.085 73.27h14.969l1.177-9.084H10.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8631F",
    d: "M21.35 64.187h3.56v2.27h-3.56zM14.23 64.187h3.56v2.27h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A35714",
    d: "M27.722 68.728H26.69v-2.271h1.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A66B29",
    d: "M10.662 62.658h17.817v1.529H10.662z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332318",
    d: "M10.909 62.415H28.23v1.326H10.909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD934E",
    d: "M10.662 61.732h17.817v1.326H10.662z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A35714",
    d: "M12.45 66.457h3.56v2.27h-3.56zM19.57 66.457h3.56v2.27h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8631F",
    d: "M21.35 68.728h3.56v2.27h-3.56zM14.23 68.728h3.56v2.27h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A35714",
    d: "m28.043 71-.606 2.27h-.748V71zM12.45 71h3.56v2.272h-3.56zM19.57 71h3.56v2.272h-3.56z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#AD6F2B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.91 66.457v-2.27h3.32l-.293 2.27zM11.202 66.457l-.294-2.27h3.323v2.27zM17.79 64.186h3.56v2.271h-3.56zM23.13 66.457h3.56v2.271h-3.56zM11.202 66.457h1.354v2.27h-1.034z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.01 66.457h3.56v2.271h-3.56zM27.349 71h-2.44v-2.272h2.733zM11.497 68.728h2.734V71h-2.439z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.79 68.727h3.56v2.271h-3.56zM23.13 71h3.56v2.271h-3.56zM13.146 71v2.27h-.75L11.792 71zM16.01 71h3.56v2.271h-3.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.3,
    d: "M28.148 64.83h-7.85l-.52.682-.929-.682h-7.858l-.083-.644h17.323z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.1,
    d: "M24.806 58.28h-2.798l1.05-1.374h2.798z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#453021",
    d: "M6.273 73.27h14.968l1.177-9.084H5.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M19.097 66.457v-2.27h3.321l-.293 2.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M15.538 64.186h3.56v2.271h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "m5.39 66.457-.294-2.27h3.323v2.27zM11.978 64.186h3.56v2.271h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M8.419 64.186h3.56v2.271h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M21.91 68.728h-1.034v-2.271h1.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M4.848 62.658h17.817v1.529H4.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#453021",
    d: "M5.096 62.415h17.322v1.326H5.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1A356",
    d: "M4.848 61.732h17.817v1.326H4.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M17.317 66.457h3.56v2.27h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M6.638 66.457h3.56v2.27h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M5.39 66.457h1.353v2.27H5.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M13.757 66.457h3.56v2.27h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M10.198 66.457h3.56v2.27h-3.56zM21.536 71h-2.439v-2.272h2.733z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M15.538 68.728h3.56v2.27h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M5.684 68.728H8.42V71h-2.44zM11.979 68.728h3.56v2.27h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M8.419 68.728h3.56v2.27h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "m22.23 71-.605 2.27h-.749V71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M17.317 71h3.56v2.272h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M6.638 71h3.56v2.272h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M7.334 71v2.27h-.75L5.98 71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M13.757 71h3.56v2.272h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.3,
    d: "M14.231 61.731h2.8l-1.875 2.455h-2.798z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M10.198 71h3.56v2.272h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.3,
    d: "M22.336 64.83h-7.851l-.52.682-.928-.682H5.179l-.083-.644h17.322z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A16F31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.17 63.553 6.328-8.286 1.795 1.314-6.328 8.287z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.1 56.126.811-1.062 1.795 1.315-.81 1.062z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.38 63.073a.654.654 0 0 0 .137.928c.298.22.724.158.948-.135a.654.654 0 0 0-.137-.927.687.687 0 0 0-.948.134z",
    fill: "#BE7A2F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m11.714 63.55 6.328-8.286 1.795 1.315-6.328 8.287z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m17.645 56.12.811-1.061 1.795 1.314-.81 1.062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.925 63.073a.653.653 0 0 0 .137.928c.3.22.726.158.947-.135a.653.653 0 0 0-.137-.927.686.686 0 0 0-.947.134z",
    fill: "#BE7A2F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16F31",
    d: "M26.06 57.905h-6.724l.502-1.326h6.725z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D19040",
    d: "M24.767 55.264h-6.724l1.795 1.326h6.725z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16F31",
    d: "M19.793 57.234h-.457l-5.825 7.632h.455z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.784 59.466h3.57c.768 0 1.394.612 1.394 1.365 0 .09-.075.164-.167.164h-.096v-.032a.163.163 0 0 1-.072-.134c0-.57-.473-1.037-1.058-1.037h-3.571a.166.166 0 0 1-.167-.164c0-.09.075-.164.167-.164v.002z",
    fill: "#7A8FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.362 60.805h.24c0-.585.307-1.062.685-1.062.378 0 .684.475.684 1.062h.24c0-.73-.415-1.326-.924-1.326-.51 0-.925.595-.925 1.326zM24.694 59.466h3.57c.768 0 1.394.612 1.394 1.365 0 .09-.075.164-.167.164a.166.166 0 0 1-.168-.164c0-.571-.474-1.037-1.058-1.037h-3.571a.166.166 0 0 1-.168-.164c0-.09.075-.164.168-.164z",
    fill: "#A3BFD6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0E0E1A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.704 59.908c0 1.008.86 1.823 1.92 1.823s1.92-.815 1.92-1.823c0-1.007-.86-1.18-1.92-1.18s-1.92.171-1.92 1.18zM18.033 59.908c0 1.008.86 1.823 1.92 1.823s1.92-.815 1.92-1.823c0-1.007-.86-1.18-1.92-1.18s-1.92.171-1.92 1.18z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#191A2E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.542 59.908c0 1.008.86 1.823 1.92 1.823s1.92-.815 1.92-1.823c0-1.007-.86-1.18-1.92-1.18s-1.92.171-1.92 1.18zM17.871 59.908c0 1.008.86 1.823 1.92 1.823s1.92-.815 1.92-1.823c0-1.007-.86-1.18-1.92-1.18s-1.92.171-1.92 1.18z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.219 60.641c-.297.643-.973 1.092-1.759 1.092-.93 0-1.707-.63-1.882-1.467 1.326.058 2.56.19 3.64.375zM20.993 60.23c.231 0 .459.002.686.008-.163.85-.946 1.495-1.888 1.495s-1.647-.582-1.86-1.37c.962-.085 1.99-.132 3.062-.132z",
    fill: "#0E0E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.502 58.84.472.638a.38.38 0 0 1-.047.499.301.301 0 0 1-.203.079.314.314 0 0 1-.25-.13l-.88-1.196c.335.006.645.035.91.11h-.002z",
    fill: "#46565C",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.855 59.107 1.4 1.694a.311.311 0 0 1-.047.444.327.327 0 0 1-.453-.046l-1.203-1.457c.03-.28.137-.486.304-.635h-.001z",
    fill: "#617280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.056 59.324a.449.449 0 0 1 .623.065l1.325 1.604c-.178.23-.415.418-.686.549l-1.328-1.606a.427.427 0 0 1 .066-.61v-.002z",
    fill: "#7A90A1",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.791 58.73c.286 0 .557.014.8.056l.537.71a.36.36 0 0 1-.047.483.307.307 0 0 1-.453-.052l-.908-1.195h.07l.001-.002z",
    fill: "#46565C",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.871 59.908c0-.296.076-.52.207-.689l1.334 1.614a.311.311 0 0 1-.047.444.323.323 0 0 1-.204.07.323.323 0 0 1-.25-.118l-1.038-1.256v-.067l-.002.002z",
    fill: "#617280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.214 59.358a.449.449 0 0 1 .622.064l1.398 1.69c-.2.216-.45.386-.734.492l-1.352-1.635a.427.427 0 0 1 .066-.61v-.001z",
    fill: "#7A90A1",
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.058 50.376)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C86BD",
    fillRule: "nonzero",
    d: "M1.842 10.63h3.721v1.326H1.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5597D4",
    fillRule: "nonzero",
    d: "M1.842 10.63h3.721l.797-6.405H1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7092B3",
    fillRule: "nonzero",
    d: "m6.07 4.225-.763 6.121H2.096l-.762-6.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7092B3",
    fillRule: "nonzero",
    d: "m6.07 4.225-.763 6.121H2.096l-.762-6.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7A016",
    fillRule: "nonzero",
    d: "m5.947 5.216-.64 5.13H2.096l-.64-5.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79216",
    fillRule: "nonzero",
    d: "M4.185 5.216h1.762l-.64 5.13H4.185z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E37F05",
    fillRule: "nonzero",
    d: "M5.322 5.216h.96l-.85 5.13h-.504z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF36",
    fillRule: "nonzero",
    d: "M2.071 5.216h1.354v5.13H2.58zM4.83 6.381c0 .365.3.663.677.663a.667.667 0 0 0 .677-.663c0-.368-.301-.663-.677-.663a.667.667 0 0 0-.677.663zm.12.118c0-.365.304-.663.677-.663.373 0 .677.298.677.663a.671.671 0 0 1-.677.663.671.671 0 0 1-.677-.663z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.397 7.306c0 .364.3.663.677.663a.667.667 0 0 0 .677-.663c0-.368-.301-.663-.677-.663a.667.667 0 0 0-.677.663zm.12.118c0-.366.304-.663.677-.663.373 0 .677.297.677.663a.671.671 0 0 1-.677.663.671.671 0 0 1-.677-.663z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.466 9.558c0 .364.301.663.677.663a.667.667 0 0 0 .677-.663c0-.368-.3-.663-.677-.663a.667.667 0 0 0-.677.663zm.12.118c0-.365.304-.663.677-.663.373 0 .677.298.677.663a.671.671 0 0 1-.677.663.671.671 0 0 1-.677-.663zM1.808 6.17a.67.67 0 0 0 .677.663.67.67 0 0 0 .677-.663.67.67 0 0 0-.677-.663.67.67 0 0 0-.677.663zm.173.17c0-.366.305-.664.677-.664.372 0 .677.298.677.663a.672.672 0 0 1-.677.663.672.672 0 0 1-.677-.663z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.332 8.413a.67.67 0 0 0 .676.663.67.67 0 0 0 .677-.663.67.67 0 0 0-.677-.663.67.67 0 0 0-.676.663zm.173.17c0-.37.304-.664.676-.664.373 0 .677.299.677.663a.672.672 0 0 1-.677.663.672.672 0 0 1-.676-.663zM4.706 7.175c0 .318.258.57.583.57a.572.572 0 0 0 .582-.57.58.58 0 0 0-.582-.57.58.58 0 0 0-.583.57z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.625 6.011a.67.67 0 0 0 .681.663.662.662 0 1 0 0-1.326.675.675 0 0 0-.681.663zM5.212 9.507c0 .364.304.663.677.663a.672.672 0 0 0 .676-.663.672.672 0 0 0-.676-.663.672.672 0 0 0-.677.663z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAF36",
    fillRule: "nonzero",
    cx: 4.375,
    cy: 9.691,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04 10.63c0 .363.306.663.677.663.37 0 .677-.3.677-.663a.675.675 0 0 0-.677-.663c-.37 0-.677.3-.677.663zM1.898 6.061c0 .265.216.49.5.49.285 0 .501-.225.501-.49s-.23-.49-.5-.49c-.271 0-.501.212-.501.49zM3.245 6.308c0 .365.304.663.677.663a.671.671 0 0 0 .677-.663.671.671 0 0 0-.677-.663.671.671 0 0 0-.677.663z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.634 7.737a.67.67 0 0 0 .676.663.665.665 0 0 0 .677-.663.67.67 0 0 0-.677-.663.665.665 0 0 0-.676.663z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.459 8.742a.6.6 0 0 0 .61.597.6.6 0 0 0 .609-.597.6.6 0 0 0-.61-.596.6.6 0 0 0-.609.596z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.708 7.131c-1.26-.241-2.213-1.328-2.213-2.633 0-.093.005-.185.015-.273h2.56l-.362 2.906z",
    fill: "#A15A0E",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.167 8.969c0 .367.302.663.677.663a.669.669 0 0 0 .677-.663.669.669 0 0 0-.677-.663.669.669 0 0 0-.677.663z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.824 8.868h.82c.182 0 .33.145.33.324v.803a.328.328 0 0 1-.33.324h-.82a.328.328 0 0 1-.331-.324v-.803c0-.179.148-.324.33-.324z",
    fill: "#74ACC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.456 9.55V10.193l-1.354-.866.135-.46h.149l1.067.683h.003z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B9FB5",
    d: "M5.358 10.501 4.004 9.76l.202-.584 1.152.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.369 8.868h.82c.182 0 .33.145.33.324v.803a.328.328 0 0 1-.33.324h-.82a.328.328 0 0 1-.331-.324v-.803c0-.179.148-.324.33-.324z",
    fill: "#86C7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28 10.34h.391c.19 0 .341-.09.341-.2v-.922c0-.112-.154-.201-.34-.201h-.777c-.133 0-.237.061-.237.14 0 .078.104.139.237.139h.647v.768h-.259c-.13 0-.237.06-.237.14 0 .077.108.139.237.139l-.003-.002z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.576 10.34c.219 0 .39-.15.39-.342V9.7h.19c.218 0 .39-.15.39-.343 0-.192-.172-.343-.39-.343h-.402c-.314 0-.562.224-.562.494v.489c0 .187.177.343.39.343h-.006z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#779CBF",
    fillRule: "nonzero",
    d: "M2.061 5.55h1.227V4.226H1.934z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.83 8.13.302-.748a.334.334 0 0 1 .43-.182l.762.295c.17.065.253.254.186.42l-.3.747a.334.334 0 0 1-.43.183l-.763-.295a.322.322 0 0 1-.186-.42z",
    fill: "#74ACC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.101 8.241a.278.278 0 0 1-.016.049l-.162.373-1.176-1.079.27-.247.155.058.926.85.003-.004z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B9FB5",
    d: "M5.623 8.934 4.49 7.948l.39-.34.964.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.406 7.976.302-.747a.334.334 0 0 1 .429-.182l.763.295c.17.066.253.254.186.42l-.302.747a.334.334 0 0 1-.429.183l-.762-.295a.322.322 0 0 1-.187-.421z",
    fill: "#86C7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.275 8.552.316.08c.153.036.325-.01.385-.107l.5-.799c.06-.096-.016-.204-.169-.244l-.628-.155c-.107-.026-.225.006-.266.073-.04.066.01.141.116.169l.522.13-.416.665-.21-.054c-.106-.025-.225.006-.268.073-.041.067.009.142.115.17h.003z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.989 8.47c.171.072.363-.017.43-.208l.105-.296.147.067c.171.073.363-.017.434-.207.066-.19-.015-.403-.187-.481l-.323-.14c-.248-.106-.525.028-.621.302l-.177.487c-.066.19.015.403.187.481l.005-.006z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5EEF6",
    d: "M0 .522 1.276.078l3.603 9.937-1.276.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD7DE",
    d: "M.011.58 1.287.137l3.603 9.937-1.276.443z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C93E47",
    d: "M.42.468 1.697.024l3.61 9.934-1.275.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB2E36",
    d: "M.112.577 1.388.134l3.6 9.938-1.276.443z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5 8.035.691-.43a.336.336 0 0 1 .457.1l.44.677a.32.32 0 0 1-.102.447l-.692.431a.336.336 0 0 1-.457-.1l-.44-.677a.32.32 0 0 1 .102-.448z",
    fill: "#74ACC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.956 7.674s.018.059.026.091l.186.728L2.86 9l-.047-.747.113-.176 1.031-.403h-.002z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B9FB5",
    d: "m4.303 8.87-1.284.438-.07-.957 1.093-.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.119 8.271.692-.43a.336.336 0 0 1 .457.099l.44.677a.32.32 0 0 1-.102.448l-.692.43a.336.336 0 0 1-.457-.099l-.44-.678a.32.32 0 0 1 .102-.447z",
    fill: "#86C7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.537 9.24.21-.125c.1-.06.13-.188.066-.285l-.534-.797a.224.224 0 0 0-.298-.063l-.418.251a.137.137 0 0 0-.046.197.154.154 0 0 0 .208.043l.347-.207.445.662-.14.085a.137.137 0 0 0-.045.197.154.154 0 0 0 .208.043h-.003z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.161 9.588c.207-.092.267-.276.134-.418l-.207-.226.18-.078c.207-.092.267-.276.14-.418-.133-.143-.4-.184-.608-.092l-.387.17c-.294.128-.38.4-.194.602l.334.364c.134.142.401.184.608.092v.004z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6583A1",
    fillRule: "nonzero",
    d: "M6.377 5.55H5.221l.09-1.325h1.264z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.566 1.617)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tky4qg8l5b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#efrgk11kya"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#tky4qg8l5b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.674 -.718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.167 3.325c0-1.267.942-2.315 2.178-2.515V.77h.43c1.44 0 2.608 1.145 2.608 2.555 0 1.41-1.167 2.554-2.608 2.554h-.43v-.038c-1.236-.2-2.178-1.25-2.178-2.516z",
    fill: "#FF9500",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.589 3.733c0-.294.23-.537.568-.658.054.435.081.88.095 1.326-.38-.102-.65-.355-.65-.678l-.013.01z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12 3.46a.475.475 0 0 1 .948 0 .475.475 0 0 1-.948 0z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.156 3.082a.475.475 0 0 0 .948 0 .475.475 0 0 0-.948 0z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.798 2.57c0 .305.257.557.555.557a.575.575 0 0 0 .569-.557.566.566 0 0 0-.569-.557.555.555 0 0 0-.555.557z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.693 2.115a.297.297 0 0 0 .596 0 .297.297 0 0 0-.299-.291.297.297 0 0 0-.297.291z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.641 2.19a.6.6 0 0 1-.61-.597.57.57 0 0 1 .15-.384c.352.172.69.37 1.029.57a.602.602 0 0 1-.569.397v.014z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.509 1.63c0 .357.297.662.677.662a.664.664 0 1 0 0-1.326.664.664 0 0 0-.677.663z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.308 1.31c0 .224-.19.41-.42.41a.418.418 0 0 1-.42-.41.36.36 0 0 1 .041-.173c.271.053.528.106.8.172z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.016 2.067a.67.67 0 0 0 .677.663.67.67 0 0 0 .677-.663.67.67 0 0 0-.677-.663.67.67 0 0 0-.677.663zM5.755 4.113c0 .37.307.663.677.663.37 0 .677-.3.677-.663a.674.674 0 0 0-.677-.663c-.37 0-.677.3-.677.663z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.936 4.633c0 .36.297.663.677.663a.662.662 0 1 0 0-1.326c-.38 0-.677.29-.677.663z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.932 5.012a.6.6 0 0 0 .61.597.6.6 0 0 0 .609-.597.6.6 0 0 0-.61-.597.6.6 0 0 0-.609.597z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.653 4.752c.149 0 .27.038.393.1-.312.42-.65.83-1.002 1.226a.746.746 0 0 1-.244-.545c0-.434.38-.78.853-.78z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FA8C16",
    fillRule: "nonzero",
    cx: 6.22,
    cy: 5.436,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59 5.684c0 .239.204.438.447.438a.446.446 0 0 0 .447-.438.446.446 0 0 0-.447-.437.446.446 0 0 0-.446.437z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.973 5.716c0 .365.304.663.677.663a.671.671 0 0 0 .677-.663.671.671 0 0 0-.677-.663.671.671 0 0 0-.677.663z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.659 5.478c.322 0 .59.226.657.53a15.2 15.2 0 0 1-1.113.65.653.653 0 0 1-.241-.504c0-.37.308-.676.683-.676h.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.842 6.169c0 .238.203.437.447.437a.446.446 0 0 0 .447-.437.446.446 0 0 0-.447-.438.446.446 0 0 0-.447.438z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.305 6.26c0 .345.284.61.623.61a.624.624 0 0 0 .623-.61.615.615 0 0 0-.623-.61.624.624 0 0 0-.623.61zM7.235 3.677c-.067.453-.162.895-.284 1.326-.244-.136-.406-.351-.406-.612 0-.351.298-.635.69-.714z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.425 3.966c0 .212.176.385.393.385a.389.389 0 0 0 .392-.385.389.389 0 0 0-.392-.384.389.389 0 0 0-.393.384zM6.27 2.469c0-.133.04-.252.095-.358.23.371.433.742.636 1.127-.406-.04-.731-.358-.731-.77z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E07E14",
    cx: 3.345,
    cy: 3.325,
    rx: 2.608,
    ry: 2.554
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF9E16",
    transform: "rotate(-45 3.344 3.326)",
    cx: 3.344,
    cy: 3.326,
    r: 2.358
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.047 3.325c0 1.243 1.028 2.25 2.298 2.25 1.269 0 2.297-1.007 2.297-2.25s-1.028-2.25-2.297-2.25c-1.27 0-2.298 1.007-2.298 2.25z",
    fill: "#F7E6B4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.36 3.062a.135.135 0 0 0 .126-.085l.544-1.53a.125.125 0 0 0-.083-.16 1.89 1.89 0 0 0-1.174 0 .125.125 0 0 0-.083.16l.545 1.53a.13.13 0 0 0 .125.085zM3.36 5.458c.2 0 .396-.032.587-.094a.125.125 0 0 0 .083-.16l-.544-1.53a.135.135 0 0 0-.251 0l-.545 1.53a.126.126 0 0 0 .082.16c.19.062.39.094.586.094h.002z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.535 3.14a.13.13 0 0 0 .148.023l1.48-.714a.123.123 0 0 0 .058-.168c-.086-.173-.199-.33-.336-.462a1.767 1.767 0 0 0-.472-.33.127.127 0 0 0-.171.057l-.73 1.45a.124.124 0 0 0 .024.145l-.001-.002zM1.805 4.833c.135.135.295.245.472.33a.13.13 0 0 0 .173-.057l.73-1.45a.124.124 0 0 0-.025-.145.13.13 0 0 0-.149-.024l-1.48.715a.123.123 0 0 0-.058.167c.086.174.2.33.337.463v.001z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.612 3.346c0 .055.035.105.086.124l1.563.536a.129.129 0 0 0 .163-.082 1.8 1.8 0 0 0 0-1.156.129.129 0 0 0-.163-.082l-1.563.537a.129.129 0 0 0-.086.123zM1.167 3.346c0 .196.032.39.096.578a.129.129 0 0 0 .164.082l1.562-.536a.129.129 0 0 0 .087-.124.13.13 0 0 0-.087-.123l-1.562-.537a.13.13 0 0 0-.164.08 1.8 1.8 0 0 0-.096.578v.002z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.535 3.511a.124.124 0 0 0-.025.146l.73 1.449c.032.063.109.088.17.057a1.726 1.726 0 0 0 .81-.792.126.126 0 0 0-.059-.167l-1.48-.715a.131.131 0 0 0-.148.024l.002-.002zM1.805 1.817c-.136.133-.25.29-.337.462a.122.122 0 0 0 .058.168l1.48.714c.049.024.11.015.149-.024a.122.122 0 0 0 .024-.143l-.73-1.45a.128.128 0 0 0-.17-.057 1.767 1.767 0 0 0-.473.33h-.001z"
  })))))), /*#__PURE__*/React.createElement("path", {
    fill: "#4578AB",
    fillRule: "nonzero",
    d: "M3.446 10.63h1.991v1.326H3.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4171A1",
    fillRule: "nonzero",
    d: "M4.538 10.63h1.354v1.326H4.538z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#518FC9",
    fillRule: "nonzero",
    d: "M2.124 10.63h1.354v1.326H2.124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M5.307 10.346H2.096l-.762-6.121h4.737z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.503 6.794c.016-.195.26-.343.549-.332.285.013.503.181.484.376l-.318 3.51H4.183l.323-3.554h-.003zM2.966 4.225l.208 2.083c.02.195-.22.363-.534.375-.318.013-.584-.136-.605-.331L1.82 4.225H2.966z",
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M3.397 4.225h2.674l-.764 6.121h-1.91z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtRetirement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-retirement.f2bc09c3d57d9995636a9b4528ebdfe4.svg";